import React from 'react';
import { FooterWrapper, PoweredByButton, PoweredByText, FooterLogo } from './Footer.styles';
import imgUrbanDark from '../../assets/PNG/urbanCompass_dark.png';
import imgUrbanLight from '../../assets/PNG/urbanCompass_light.png';
import { URBAN_COMPASS_SITE } from '../../settings/constant';

const Footer = ({ isDark = true }) => {
  const handleOpenToSite = () => {
    window.open(URBAN_COMPASS_SITE, '_blank');
  };
  return (
    <FooterWrapper>
      <PoweredByButton type="button" onClick={handleOpenToSite}>
        <PoweredByText>Powered by</PoweredByText>
        <FooterLogo src={isDark ? imgUrbanDark : imgUrbanLight} alt="Urban Compass" />
      </PoweredByButton>
    </FooterWrapper>
  );
};

export default Footer;
